<template>
  <div>
    <top-bar/>
    <div class="content" style="padding: 72px 0">
      <div class="container-fluid">
        <menu-option :menus="menus" :selected="menu" @changeMenu="changeMenu"/>
        <div class="mt-5" v-if="load">
          <loading/>
        </div>

        <div v-else-if="menu === 1">
          <div class="row justify-content-between mb-3">
            <div class="col-md-3">
              <select class="form-control" v-model="search.status" @change="getBusiness()">
                <option value="1">Ativas</option>
                <option value="2">Pausadas</option>
                <option value="0">Canceladas</option>
              </select>
            </div>
            <div class="col-md-3 text-right">
              <button class="btn btn-primary px-4" @click="newBusiness"><i class="fa fa-plus mr-1"></i> Empresa</button>
            </div>
          </div>
          <div class="card shadow-sm" style="min-height: 100px">
            <div class="card-body">
              <table class="table mb-0">
                <thead>
                <tr class="small">
                  <th>Nome</th>
                  <th>Status</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="e in business">
                  <td class="align-middle pointer" @click="editBusiness(e)">{{ e.name }}</td>
                  <td class="align-middle pointer" @click="editBusiness(e)">{{ e.fg_ativo | status }}</td>
                  <td class="text-right">
                    <button class="btn btn-primary btn-sm" @click="editBusiness(e)" style="width: 32px"><i class="fa fa-pencil-alt"></i></button>
                    <button class="btn btn-dark btn-sm ml-2" @click="loginBusiness(e.id)" style="width: 32px"><i class="fa fa-sign-in-alt"></i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal @salvar="saveModal">
      <loading v-if="loadModal"/>
      <div v-else-if="busi && menu === 1">
        <h5>{{ busi.name || 'Empresa' }}</h5>
        <hr>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="font-weight-bold small mb-0">Nome</label>
            <input class="form-control mb-2" placeholder="Nome da Empresa" v-model="busi.name" maxlength="64" required>
          </div>
          <div class="col-md-6 mb-3">
            <label class="font-weight-bold small mb-0">Status</label>
            <select class="form-control" v-model="busi.fg_ativo" required>
              <option :value="1">Ativada</option>
              <option :value="2">Pausada</option>
              <option :value="0">Cancelada</option>
            </select>
          </div>
        </div>
        <div class="small" v-if="busi.id">
          <div><b>ID:</b> {{busi.id}}</div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService'
import TopBar from "@/components/TopBar";
import MenuOption from "@/components/MenuOption";
import Modal from "@/components/Modal";
import CardMensagem from "@/components/CardMensagem";
import Loading from "@/components/loading";
import Hours from "@/components/Hours";
export default {
  name: "Admin",
  components: {Hours, Loading, CardMensagem, Modal, MenuOption, TopBar},
  data() {
    return {
      load: true,
      loadModal: false,
      business: [],
      busi: null,
      menu: 1,
      menus: [
        { nome: 'Empresas', active: true }
      ],

      search: { status: '1' }
    }
  },

  methods: {
    changeMenu(m) {
      this.menu = m;
    },

    saveModal(callback) {
      if (this.menu === 1) {
        this.saveBusiness(callback)
      }
    },

    getBusiness() {
      this.load = true;
      this.$http.get('business', { params: this.search })
        .then(response => {
          this.load = false;
          this.business = response.data || [];

        }, res => {
          this.load = false;
          console.log(res);
        });
    },

    editBusiness(data) {
      this.busi = { id: data.id, name: data.name, fg_ativo: data.fg_ativo };
      this.$emit('openModal');
    },

    newBusiness() {
      this.loadModal = false;
      this.busi = { name: '', fg_ativo: '1' }
      this.$emit('openModal');
    },

    saveBusiness(callback) {
      this.loadModal = true;
      this.$http.post('business', this.busi)
        .then(response => {
          this.loadModal = false;

          if (response.data && response.data.id) {
            this.getBusiness();

            if (callback) {
              callback(true);
            }

          } else {
            this.$swal("Não foi possível salvar esta empresa");
          }

        }, res => {
          this.loadModal = false;
          console.log(res);
        });
    },

    loginBusiness(id) {
      this.load = true;
      this.$http.post('business/connect', { id })
        .then(async response => {
          if (response.data && response.data.success) {
            await AuthService.refreshJwt();
            localStorage.removeItem('lebot_usuario');
            window.location.href = '/'

          } else {
            this.load = false;
            this.$swal("Não foi possível logar nesta empresa");
          }

        }, res => {
          this.load = false;
          console.log(res);
        });
    }
  },

  mounted() {
    this.getBusiness();
  },

  filters: {
    status(s) {
      switch (s) {
        case 1: return 'Ativada';
        case 2: return 'Pausada';
        default: return 'Cancelada';
      }
    }
  }
}
</script>

<style scoped>
</style>
